<b>{{question.label}}</b>
<ul class="multiSelectList">
    <li *ngFor="let item of value">{{item.ArmatureDesc}}</li>
</ul>
